import React from "react";
import {
  Checkbox,
  Dialog,
  FlatButton,
  TextField,
} from "material-ui";
import { FormattedMessage, injectIntl } from "react-intl";
import DialogTitle from "../Shared/DialogTitle";
import { addAddress, destroyAddress, updateAddress } from "./actions";
import { checkJapanese, isEmailValid } from "../../lib";
import ToggleRadioButtonUnchecked from "material-ui/svg-icons/toggle/radio-button-unchecked";
import ToggleRadioButtonChecked from "material-ui/svg-icons/toggle/radio-button-checked";

class AddEmailAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      role: ["host"],
      groupIds: [],
      hasError: false,
      errorMessage: "",
      emailError: "",
      showGroup: false,
      isEmailAlreadyUsed: false,
      errors: {
        name: "",
        email: "",
        role: ""
      }
    };
  }

  componentDidMount() {
    if (this.props.isEdit && this.props.selectedAddress) {
      this.setState({
        name: this.props.selectedAddress.name,
        email: this.props.selectedAddress.email_address,
        role: this.props.selectedAddress.role.split(','),
        groupIds: this.props.selectedAddress.group_ids.map(i => parseInt(i)) || null,
      });
    }
  }

  resetError = (fieldName = null) => {
    this.setState({ hasError: false, errorMessage: "" });

    if(fieldName && this.state.errors[fieldName] !== '') {
      let errors = this.state.errors;
      switch(fieldName) {
        case 'name' : errors.name = "";
          this.setState({ errors });
          break;
        case 'email' : errors.email = "";
          this.setState({ errors });
          break;
        case 'role' : errors.role = "";
          this.setState({ errors });
        break;
      }
    }

  };

  setEmailExistsError = () => {
    this.setState({
      emailError: checkJapanese() 
        ? "すでにアドレス帳に登録されているメールアドレスは追加できません。別の連絡先をご指定ください。" 
        : "This email address is the same one in address book. Please add new email address." 
    });
  }

  isFormValid = () => {
    return this.state.name !== '' && this.state.email !== '' && this.state.role.length !== 0;
  }

  setFormError = () => {
    let errors = this.state.errors;
    if(this.state.name === '') {
      errors.name = this.props.intl.formatMessage({ id: "emailAddressBook.addName"});
    }
    if(this.state.email === '') {
      errors.email = this.props.intl.formatMessage({ id: "emailAddressBook.addEmail"});
    }
    if(this.state.role.length === 0) {
      errors.role = this.props.intl.formatMessage({ id: "emailAddressBook.selectRoleError"});
    }

    this.setState({ errors }); 
  }


  handleSubmit = () => {
    if(!this.isFormValid()) {
      this.setFormError();
      return;
    }
    let isEmailFormatValid = isEmailValid(this.state.email);

    if(!isEmailFormatValid) {
      this.setState({
        emailError: checkJapanese() 
          ? "メールアドレスの形式が正しくありません。もう一度確認の上お試しください。" 
          : "You have added an invalid email format. Please check your email address and try again."
      });
      return;
    }

    let isEmailAlreadyExists = this.props.emailAddressBook.find(a => a.email_address === this.state.email);
    if(this.props.isEdit) {
      if(this.props.selectedAddress.email_address !== this.state.email && isEmailAlreadyExists) {
        this.setEmailExistsError();
        return
      }
    } else if(isEmailAlreadyExists) {
      this.setEmailExistsError();
      return;
    }

    const data = {
      name: this.state.name,
      email_address: this.state.email,
      role: this.state.role.toString(),
      group_ids: this.state.groupIds,
    };

    if (this.props.isEdit) {
      data.id = this.props.selectedAddress.id;
      updateAddress(data)
        .then((r) => {
          this.props.showNotification(<FormattedMessage id="emailAddressBook.addressSaved"/>, 'success')
          this.props.onSuccess(r.data.address_book)
        })
        .catch((error) => {
          this.setState({ hasError: true, errorMessage: checkJapanese() ? "サーバでエラーが発生しました。アドレスを更新できません。" : "Unable to update the address, server error occurred."});
          console.log("Error: ", error);
        });
    } else {
      addAddress(data)
        .then((r) => {
          this.props.showNotification(<FormattedMessage id="emailAddressBook.addressSaved"/>, 'success')
          this.props.onSuccess(r.data.address_book);
        })
        .catch((error) => {
          this.setState({ hasError: true, errorMessage: checkJapanese() ? "サーバでエラーが発生しました。アドレスを追加できません。" : "Unable to add the address, server error occurred."});
          console.log("Error: ", error);
        });
    }
  };

  deleteAddress = () => {
    let confirmation = window.confirm(
      checkJapanese() ? "メールアドレスを削除してよろしいですか？" : "Are you sure you want to delete this email address?" 
    );
    if (confirmation) {
      if (
        this.props.isEdit &&
        this.props.selectedAddress &&
        this.props.selectedAddress.id
      ) {
        destroyAddress(this.props.selectedAddress.id)
          .then((r) => this.props.onSuccess())
          .catch((error) => {
            this.setState({ hasError: true, errorMessage: checkJapanese() ? "サーバでエラーが発生しました。アドレスを削除できません。" : "Unable to delete the address, server error occurred."});
            console.log("Error: ", error);
          });
      }
    }
  };

  handleGroupSelect = (groupId) => {
    let groupIds = this.state.groupIds;
    groupIds.includes(groupId) ? groupIds = groupIds.filter(i => i!== groupId) : groupIds.push(groupId);
    this.setState({ groupIds });
  };

  handleRoleSelect = (value) => {
    let role = this.state.role;
    role.includes(value) ? role = role.filter(r => r !== value) : role.push(value);
    this.setState({ role });
    this.resetError("role");
  }

  render() {
    const actions = [
      <FlatButton
        label={<FormattedMessage id="emailAddressBook.cancel" />}
        labelStyle={{ color: "#858585" }}
        onClick={this.props.handleClose}
      />,
      <FlatButton
        backgroundColor="#60d1bd"
        hoverColor="#60d1bd"
        label={<FormattedMessage id="emailAddressBook.save" />}
        labelStyle={{ color: "#fff" }}
        onClick={this.handleSubmit}
      />,
    ];

    if (this.props.isEdit) {
      actions.unshift(
        <FlatButton
          backgroundColor="#d75654"
          hoverColor="#d75654"
          label={<FormattedMessage id="emailAddressBook.delete" />}
          labelStyle={{ color: "#fff" }}
          onClick={this.deleteAddress}
        />
      );
    }

    let labelStyle = {
      color: "#657285",
      fontSize: "14px",
      marginTop: "8px",
      
    };

    let textFieldStyle = {
      backgroundColor: "#fff",
      height: "38px",
      margin: "8px 0",
    };

    let inputStyle = {
      border: "1px solid #657285ab",
      height: "38px",
      padding: "0 8px",
      fontSize: "13px",
      color: "#657285"
    };

    return (
      <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={<FormattedMessage id="emailAddressBook.addNew" />}
            handleClose={this.props.handleClose}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "550px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        actions={actions}
        actionsContainerStyle={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "rgb(241, 241, 241)",
          padding: "12px 28px 15px",
        }}
        className="popup-modal"
        bodyClassName="popup-modal-body"
      >
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              <FormattedMessage id="emailAddressBook.name" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              inputStyle={inputStyle}
              name="name"
              value={this.state.name}
              onChange={(e) => {
                this.resetError("name");
                this.setState({ name: e.target.value });
              }}
              autoComplete="off"
            />
            {this.state.errors.name && <label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}>{this.state.errors.name}</label>}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              <FormattedMessage id="emailAddressBook.emailAddress" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              inputStyle={inputStyle}
              value={this.state.email}
              name="email"
              onChange={(e) => {
                this.resetError("email");
                this.setState({ email: e.target.value, emailError: '' });
              }}
              // placeholder={placeholders.room}
              autoComplete="off"
            />
            {this.state.errors.email && <label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}>{this.state.errors.email}</label>}
            {this.state.emailError && <label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}>{this.state.emailError}</label>}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label className="width-auto" onClick={() => this.setState({ showGroup: !this.state.showGroup })} style={labelStyle}>
              <FormattedMessage id="emailAddressBook.group" />
            </label>
            <div style={{ border: '1px solid #657285ab', padding: '8px', backgroundColor: '#fff', marginTop: '5px', maxHeight: '156px', overflowX: 'hidden', overflowY: this.props.groups.length === 0 ? 'hidden' : 'scroll', }}>
              {this.props.groups.length === 0 && <label style={{ fontSize: '14px', color: '#b4b4b4' }}><FormattedMessage id="emailAddressBook.noAvailableGroup" /></label>}
              {
                this.props.groups.map(group => {
                  return (
                    <Checkbox
                      key={group.id}
                      label={group.name}
                      checked={this.state.groupIds.includes(group.id)}
                      onCheck={() => this.handleGroupSelect(group.id)}
                      labelStyle={{
                        color: '#657285'
                      }}
                      iconStyle={{
                        fill: "#657285"
                      }}
                      style={{
                        margin: '4px 0'
                      }}
                    />
                  )
                })
              }
            </div>         
          </div>

          <div
            className="d-flex add-question-radio"
            style={{ marginTop: "12px" }}
          >
            <label style={{ ...labelStyle, marginTop: "4px" }}>
              <FormattedMessage id="emailAddressBook.role" />
            </label>
            <div style={{ marginLeft: '12px', minWidth: '140px' }}>
              <Checkbox
                checkedIcon={<ToggleRadioButtonChecked />}
                uncheckedIcon={<ToggleRadioButtonUnchecked style={{ fill: "#657285"}} />}
                label={<FormattedMessage id="emailAddressBook.host" />}
                labelStyle={{ ...labelStyle, marginTop: 0 }}
                style={{ marginBottom: '8px' }}
                checked={this.state.role.includes('host')}
                onCheck={() => this.handleRoleSelect('host')}
              />
              <Checkbox
                checkedIcon={<ToggleRadioButtonChecked />}
                labelStyle={{ ...labelStyle, marginTop: 0 }}
                uncheckedIcon={<ToggleRadioButtonUnchecked style={{ fill: "#657285"}} />}
                checked={this.state.role.includes('participant')}
                label={<FormattedMessage id="emailAddressBook.participant" />}
                onCheck={() => this.handleRoleSelect('participant')}
              />
            </div>
          </div>
          {this.state.errors.role && <div style={{ marginTop: "6px" }}><label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px'  }}>{this.state.errors.role}</label></div>}
          {this.state.hasError && this.state.errorMessage && <div className="error-message">{this.state.errorMessage}</div>}
        </div>
      </Dialog>
    );
  }
}

export default injectIntl(AddEmailAddress);



// WEBPACK FOOTER //
// src/components/EmailAddressBook/AddEmailAddress.js